const SENTRY_DSN = process.env.SENTRY_DSN ?? '';

export default SENTRY_DSN;
